"use client";
import { motion, AnimatePresence } from "framer-motion";
import { XIcon } from "lucide-react";
import { BlogSort } from "./blog-sort";
import { BlogCategories } from "./blog-categories";
import { BlogTags } from "./blog-tags";
import { Tag } from "@/app/types/blogTypes";
import { useRouter, useSearchParams } from "next/navigation";

interface BottomSheetProps {
  onClose: () => void;
  isOpen: boolean;
  tags: Tag[];
}

export const BottomSheet = ({ onClose, isOpen, tags }: BottomSheetProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const hasFilters = searchParams.has("category") || searchParams.has("sort");

  const clearFilters = () => {
    const newParams = new URLSearchParams(searchParams.toString());
    newParams.delete("category");
    newParams.delete("sort");

    const newUrl = `/blog${
      newParams.toString() ? `?${newParams.toString()}` : ""
    }`;
    router.push(newUrl);
  };
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-end"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className="bg-white p-6 rounded-t-2xl flex flex-col w-full max-w-lg"
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-center">
              <div className="h-1 w-12 bg-neutral-200 rounded-full"></div>
            </div>
            <div className="flex w-full justify-between mt-5">
              <h2 className="text-lg text-gray-800">Filtrar conteúdo</h2>
              <button onClick={onClose} className="text-neutral-400">
                <XIcon size={20} />
              </button>
            </div>
            <div className="flex flex-col mt-6 gap-6">
              <div className="flex flex-col gap-2">
                <span className="text-xs text-neutral-500">
                  Selecione os tópicos
                </span>
                {/* <BlogCategories type="select" categories={categories} /> */}
                <BlogTags tags={tags} onClose={onClose} />
              </div>
              <div className="flex flex-col gap-2">
                <span className="text-xs text-neutral-500">Ordenar por</span>
                <BlogSort />
              </div>

              <div className="flex gap-4 mt-4">
                {hasFilters && (
                  <button
                    onClick={clearFilters}
                    className="bg-neutral-200 text-gray-700 rounded-full py-2 px-4 text-sm"
                  >
                    Limpar Filtros
                  </button>
                )}
                <button
                  onClick={onClose}
                  className="flex-1 bg-brand-dark text-white rounded-full py-2 text-center"
                >
                  Filtrar conteúdo
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
